module.exports = __webpack_public_path__ + "img/mq_1.93cc16b2.svg";